import React, { useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import NavbarWrapper from '../../elementsWeb/Navbar';
import Drawer from '../../elementsWeb/Drawer';
import Button from '../../elementsWeb/Button';
import Logo from '../../elementsWeb/UI/Logo';
import Box from '../../elementsWeb/Box';
import HamburgMenu from '../../elementsWeb/HamburgMenu';
import { DrawerContext } from '../../assetsWeb/javascript/DrawerContext';
import ScrollSpyMenu from '../../elementsWeb/ScrollSpyMenu';
import LogoImageAlt from '../../assetsWeb/images/logo_ligth_red.png';
import LogoImage from '../../assetsWeb/images/logo_white.png';

const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  const Sitedata = useStaticQuery(graphql`
    query {
      siteJson {
        MENU_ITEMS {
          label
          path
        }
      }  
    }
  `);

  const { state, dispatch } = useContext(DrawerContext);

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  return (
    <NavbarWrapper {...navbarStyle} className="saas_navbar">
        <Box {...row} className="nav-row">
          <Logo
            href="/"
            logoSrc={LogoImage}
            title="Portfolio"
            logoStyle={logoStyle}
            className="main-logo"
          />
          <Logo
            href="/"
            logoSrc={LogoImageAlt}
            title="Portfolio"
            logoStyle={logoStyle}
            className="logo-alt"
          />
          <Box {...menuWrapper}>
            <ScrollSpyMenu
              className="main_menu"
              menuItems={Sitedata.siteJson.MENU_ITEMS}
            />
            <a href="https://dashboard.3dsecure.io/" className="navbar_button">
              <Button {...button} title="Try sandbox for free" />
            </a>
            <Drawer
              width="420px"
              placement="right"
              drawerHandler={<HamburgMenu barColor="#fff" />}
              open={state.isOpen}
              toggleHandler={toggleHandler}
            >
              <a href="https://dashboard.3dsecure.io/" className="navbar_button">Try sandbox for free</a>

              <ScrollSpyMenu
                className="mobile_menu"
                menuItems={Sitedata.siteJson.MENU_ITEMS}
                drawerClose={true}
              />
            </Drawer>
          </Box>
        </Box>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: '80px',
    display: 'block',
  },
  row: {
    flexBox: true,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  logoStyle: {
    width: 'auto',
    height: '40px'
  },
  button: {
    type: 'button',
    fontSize: '13px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '15px',
    pr: '15px',
    colors: 'secondaryWithBg',
    minHeight: 'auto',
    height: '40px',
    width: [1, 1, 'auto']
  },
  menuWrapper: {
    flexBox: true,
    alignItems: 'center',
  },
};

export default Navbar;
